import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import reducer from './reducers';
import mediaFiles from './MediaAndFiles/mediaReducers';
import sequences from './Sequences/sequenceReducers';
const reducers = combineReducers({ reducer, mediaFiles, sequences });
const store = createStore(reducers, applyMiddleware(thunk));
export default store;
